import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseButton, LinkButton } from './BaseButton';

const primaryButtonStyle = {
    background: colorSystem.primary[6],
    color: colorSystem.neutral.white,
    border: `1px solid ${colorSystem.primary[6]}`,

    '&:hover': {
        background: colorSystem.primary[7],
    },
    '&:active': {
        background: colorSystem.primary[8],
    },
    '&:disabled': {
        background: colorSystem.neutral[5],
        color: colorSystem.neutral.white,
        border: `1px solid ${colorSystem.neutral[5]}`,
    },
};

const PrimaryButtonHost = styled(BaseButton)(primaryButtonStyle);
const PrimaryButtonLinkHost = styled(LinkButton)(primaryButtonStyle);

export const PrimaryButton = linkable(PrimaryButtonHost, { linkHost: PrimaryButtonLinkHost });
